import { Component,  EventEmitter,  Input, Output } from '@angular/core';
import { DropdownOption } from 'globals/store/programs.data';
import { IconComponent } from '../icon/icon.component';
import { CommonModule } from '@angular/common';
import { DropdownComponent } from '../misc/dropdown.component';
import { FindByIdPipe } from 'src/app/services/pipes/findById.pipe';

@Component({
    selector: 'paginator',
    template: `
<div style="flex:1;"></div>
<div *ngIf="pageIndex > 0" class="prev" (click)="setPageIndex.emit(pageIndex - 1)">
  <icon icon="ARROW_BACK"></icon>
  Prev
</div>
<div class="page-button" [ngClass]="{ selected: page === pageIndex, invisible: pages.length === 1 }" *ngFor="let page of pages;" (click)="setPageIndex.emit(page)"><div class="page-number">{{ page + 1 }}</div></div>
<div *ngIf="pageIndex < pages.length - 1" class="next" (click)="setPageIndex.emit(pageIndex + 1)">
  Next
  <icon icon="ARROW_BACK"></icon>
</div>
<div style="flex:1;"></div>
<div class="IPP">
  {{ entityName }}s per page: <dropdown [selections]="itemsPerPageOptions" [selected]="itemsPerPageOptions | findById:('' + itemsPerPage)" (select)="updateItemsPP($event)"></dropdown>
</div>
`,
    styleUrls: ['paginator.scss'],
    standalone: true,
    imports: [IconComponent, FindByIdPipe, DropdownComponent, CommonModule],
})
export class PaginatorComponent {
  @Input() pageIndex: number = 0
  @Input() pages: number[] = []
  @Input() itemsPerPage: number = 10 
  @Input() entityName = 'Row'
  @Output() updateItemsPerPage: EventEmitter<number> = new EventEmitter()
  @Output() setPageIndex: EventEmitter<number> = new EventEmitter()

  updateItemsPP(dropdownOption: DropdownOption) {
    this.updateItemsPerPage.emit(+dropdownOption.id)
  }

  itemsPerPageOptions: DropdownOption[] = [
    { id: '10', title: '10' },
    { id: '25', title: '25' },
    { id: '50', title: '50' },
    { id: '100', title: '100' },
  ]
}

